import granditudeLogoDark from '#/src/images/granditude_logo_dark.svg'
import { ImageBox } from 'ui'
import { useAppConfigContext } from '#/src/appConfig'

/** Header logo. Shared by the shop layout and the maintenance page. */
export const TopNavLogo = () => {
  const appConfig = useAppConfigContext()

  return (
    <ImageBox
      h={10}
      imageProps={{
        title: 'Granditude',
        alt: 'Granditude',
        src: appConfig.logoUrl || granditudeLogoDark.src,
        style: {
          objectFit: 'contain'
        },
        quality: 100,
        priority: true,
        sizes: '10em'
      }}
      w={40}
    />
  )
}
